import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import ViewData from "./ViewData";

import {
  CenterProductsListContainer,
  HeaderWrapper,
  Title,
  AddCenterProducts,
} from "./CenterProductsList.styled";

import "./CenterProductsList.scss";
/**
 * CenterProducts List,
 * Path - /analyticalNotes
 * @see See [CenterProducts Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2920611841/Centre+products+list)
 * @component
 */
const CenterProductsList = (props) => {
  const { t, centerId, companyId, isHeader } = props;
  const [isRefreshList, setIsRefreshList] = useState(false);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  return (
    <CenterProductsListContainer className="center-products-list">
      {isHeader && (
        <HeaderWrapper>
          <Title>{t("PRODUCTS")}</Title>
        </HeaderWrapper>
      )}
      <ViewData
        updateRefeshStatus={updateRefeshStatus}
        centerId={centerId}
        companyId={companyId}
      />
    </CenterProductsListContainer>
  );
};

CenterProductsList.propTypes = {
  t: PropTypes.func.isRequired,
  isHeader: PropTypes.bool,
};

CenterProductsList.defaultProps = {
  isHeader: true,
};

export default withTranslation()(CenterProductsList);
